import { combineReducers } from 'redux';
import { invoiceEntityReducer } from './invoice';

const entitiesReducer = combineReducers({
  invoice: invoiceEntityReducer
});

export { entitiesReducer };